import { apiAuthClient } from 'api/helpers';

import type { PostOrganisationAdminRequestType } from '../types';

export const postOrganisationAdmin = async ({
  pathParams: { organisationId },
  body,
}: PostOrganisationAdminRequestType) => {
  const url = `/api/v2/organisations/${organisationId}/administrators`;
  await apiAuthClient.post<void>(url, body);
};
